var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.hasData)?_c('div',{staticClass:"-text-size-5 flex items-center justify-center -fg-semi-muted absolute-top"},[_vm._v(" Filter selection returned no members ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }